import * as React from "react";

import type { FolderItem } from "@/types/fse";
import { formatFolderContentsTotal } from "@/views/drive/components/driverRowName/folderCounts";
import { DriveHeaderBreadcrumbs } from "@/views/drive/driverHeaderBreadcrumbs";

interface Props {
  currentFolder?: FolderItem;
  parentFolder: FolderItem | null;
  isRootFolder: boolean;
  titleActions?: React.ReactNode;
  actions: React.ReactNode;
}

export const DriveWorkspaceHeader: React.FC<Props> = ({ currentFolder, isRootFolder, titleActions, actions }) => {
  const contentsTotal = currentFolder ? formatFolderContentsTotal(currentFolder) : null;

  return (
    <header className="mb-8 flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0 flex-1">
        {!isRootFolder && currentFolder && (
          <DriveHeaderBreadcrumbs currentLocation={currentFolder.current_location} currentFolder={currentFolder} />
        )}
        <div className="flex items-center gap-2">
          <h1 className="text-midnight-blue truncate text-3xl font-bold tracking-tight">
            {isRootFolder || !currentFolder ? "Documents" : currentFolder.name}
          </h1>
          {titleActions}
        </div>
        <p className="mt-1 text-sm font-medium text-gray-500">
          {isRootFolder || !currentFolder ? "All folders and files you can access across Atria." : contentsTotal}
        </p>
      </div>
      <div className="flex flex-wrap justify-start gap-2 sm:justify-end">{actions}</div>
    </header>
  );
};
